export default "__VITE_ASSET__BC9koDY8__"